module.exports = __webpack_public_path__ + "img/lang-19.cffeac60.jpg";